import { TRefElementInstance } from 'widgets/toolbox/RefElement';

/**
 * @description InputTextMixin implementation
 * @param InputText Base widget for extending
 * @returns Input Text Mixin class
 */
function InputTextMixinClassCreator(InputText: import('widgets/forms/InputText').TInputText) {
    class InputTextMixin extends InputText {
        /**
         * @description Element on focus handler
         * @listens dom#focus
         * @emits InputText#focus
         * @param el source of event
         * @param event event instance if DOM event
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onFocus(el: TRefElementInstance, event?: Event) {
            /**
             * @description Event, indicates that `focus` event happened
             * @event InputText#focus
             */
            this.emit('focus');
        }
    }

    return InputTextMixin;
}

export type TInputTextMixin = ReturnType<typeof InputTextMixinClassCreator>;

export type TInputTextMixinInstance = InstanceType<TInputTextMixin>;

export default InputTextMixinClassCreator;
